import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/platform-image-1.webp")